import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e775c8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_mx"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_box"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text_"
}, "模型配置")], -1));
const _hoisted_3 = {
  class: "box_cont"
};
const _hoisted_4 = {
  class: "btn_t"
};
const _hoisted_5 = {
  class: "tables"
};
const _hoisted_6 = {
  key: 0,
  class: "platform"
};
const _hoisted_7 = {
  key: 1,
  class: "close_s"
};
import promptDialog from "./components/prompt-dialog.vue";
import { Plus } from "@element-plus/icons-vue";
import { ref, markRaw } from "vue";
import { getprompt_list, deleteprompt_post } from "@/service/modules/alllist";
import { ElMessage, ElMessageBox } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'prompt',
  setup(__props) {
    const options = [{
      label: "全部",
      value: 0
    }, {
      label: "开启",
      value: 1
    }, {
      label: "关闭",
      value: 2
    }];
    const ConfigDialogVisible = ref(false);
    const ConfigDialogType = ref("add");
    const page = ref({
      page: 1,
      pageSize: 15
    });
    const roleListTotal = ref(100);
    const formdata = ref({
      id: "",
      name: "",
      prompt: "",
      status: 0
    });
    const dataList = ref([]);
    const loading = ref(false);
    const ConfigDialogData = ref({});
    const handleRoleTableCurrentChange = async () => {
      loading.value = true;
      let reqdata = {
        page: page.value.page,
        pageSize: page.value.pageSize,
        ...formdata.value
      };
      let res = await getprompt_list(reqdata);
      if (res.code == 0) {
        dataList.value = res.data.data;
        roleListTotal.value = res.data.total;
        loading.value = false;
      }
    };
    handleRoleTableCurrentChange();
    const closeRoleDialog = () => {
      ConfigDialogVisible.value = false;
    };
    const add_Keys = () => {
      ConfigDialogType.value = "add";
      ConfigDialogVisible.value = true;
    };
    function handleRoleTableItem(item) {
      ConfigDialogType.value = "edit";
      ConfigDialogData.value = item;
      ConfigDialogVisible.value = true;
    }
    function deleteAdminTableItem(id) {
      ElMessageBox.confirm("此操作将永久删除该数据, 是否继续？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteprompt_post(id);
          ElMessage.success("删除成功");
          handleRoleTableCurrentChange();
        } catch {}
      }).catch(() => {});
    }
    const seach = () => {
      page.value.page = 1;
      handleRoleTableCurrentChange();
    };
    const restData = () => {
      ConfigDialogVisible.value = false;
      seach();
    };
    const reset = () => {
      formdata.value = {
        id: "",
        name: "",
        prompt: "",
        status: 0
      };
      page.value.page = 1;
      handleRoleTableCurrentChange();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_proto_pagination = _resolveComponent("proto-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        inline: true,
        model: formdata.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "ID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formdata.value.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formdata.value.id = $event),
            placeholder: "请输入",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formdata.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formdata.value.name = $event),
            placeholder: "请输入",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "提示词"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formdata.value.prompt,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formdata.value.prompt = $event),
            placeholder: "请输入",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "可用性"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: formdata.value.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formdata.value.status = $event),
            placeholder: " 请选择",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item, index) => {
              return _createVNode(_component_el_option, {
                key: index,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
            type: "primary",
            style: {
              "margin-left": "100px"
            },
            onClick: seach
          }, {
            default: _withCtx(() => [_createTextVNode("查询")]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "",
            style: {
              "margin-left": "10px"
            },
            onClick: _cache[4] || (_cache[4] = $event => reset())
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = $event => add_Keys()),
            icon: _unref(Plus)
          }, {
            default: _withCtx(() => [_createTextVNode("新增")]),
            _: 1
          }, 8, ["icon"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: dataList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "70",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "prompt",
          label: "提示词",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "display_order",
          label: "排序",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "是否显示",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [scope.row.status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "显示")) : _createCommentVNode("", true), scope.row.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_7, "关闭")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "id",
          label: "维护时间",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, "更新：" + _toDisplayString(scope.row.ct_time), 1), _createElementVNode("div", null, "创建：" + _toDisplayString(scope.row.up_time), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleRoleTableItem(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => deleteAdminTableItem(scope.row.id)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]])]), _createVNode(_component_proto_pagination, {
        page: page.value,
        total: roleListTotal.value,
        onCurrentChange: handleRoleTableCurrentChange
      }, null, 8, ["page", "total"])]), _createVNode(promptDialog, {
        "dialog-visible": ConfigDialogVisible.value,
        "dialog-type": ConfigDialogType.value,
        onCloseDialog: closeRoleDialog,
        itemData: ConfigDialogData.value,
        onRestData: restData
      }, null, 8, ["dialog-visible", "dialog-type", "itemData"])]);
    };
  }
});